"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInviteRefClient = void 0;
var getInvitesRefClient_1 = require("./getInvitesRefClient");
var firestore_1 = require("firebase/firestore");
var getInviteRefClient = function (_a) {
    var firestore = _a.firestore, workspaceId = _a.workspaceId, inviteId = _a.inviteId;
    var invitesRef = (0, getInvitesRefClient_1.getInvitesRefClient)({ firestore: firestore, workspaceId: workspaceId });
    var docRef = (0, firestore_1.doc)(invitesRef, inviteId);
    return docRef;
};
exports.getInviteRefClient = getInviteRefClient;
